export default __webpack_public_path__ + "static/media/Ekierka-01.06489dd5.svg";